export var StepperOverrides = function () { return ({
    MuiStepper: {
        root: {
            padding: '12px 0',
        },
    },
}); };
//# sourceMappingURL=Stepper.overrides.js.map